<div class="container">
  <div class="page-container">
    <div class="title-bar">
      <div class="dashboard-title">Manage App Config</div>
    </div>
  </div>

  <div class="table-container">
    <table mat-table [dataSource]="dataSource" aria-describedby="Manage App Config Value">
      <ng-container matColumnDef="key">
        <th scope="col" mat-header-cell *matHeaderCellDef class="key-description-col">
          <div>
            <span>Key</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let row">{{ row.key }}</td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th scope="col" mat-header-cell *matHeaderCellDef class="key-description-col">
          <div>
            <span>Name</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let row">{{ row.description }}</td>
      </ng-container>

      <ng-container matColumnDef="value">
        <th scope="col" mat-header-cell *matHeaderCellDef class="value-col">
          <div>
            <span>Value</span>
          </div>
        </th>
        <td mat-cell *matCellDef="let row">{{ row.value }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="clickRow($event, row)"></tr>
    </table>
  </div>
</div>
